import React from 'react';
import cx from 'classnames';
import { CryptoSelectThumb } from './Thumb/index.js';
import { Options } from './Options/index.js';
import { Switch } from '../Switch/index.js';
import { Select } from '../Select/index.js';
import newTheme from './new-theme.module.scss.js';
import styles from './index.module.scss.js';

const CryptoSelect = ({
  className,
  style,
  popupGap = 10,
  theme = "light",
  isFiat = false,
  setIsFiat,
  isHideZeroBalance = false,
  setHideZeroBalance,
  options,
  inGame,
  text = {
    searchPlaceholder: "Search currencies",
    fiatSwitch: "Display in Fiat",
    zeroSwitch: "Hide zero balances",
    bet: "bet"
  },
  ...props
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement(
  Select,
  {
    ...props,
    options,
    hasSearch: true,
    popupStyle: { width: 300, minWidth: 300 },
    version: "v3",
    theme,
    text,
    renderThumb: (thumbProps) => /* @__PURE__ */ React.createElement(
      CryptoSelectThumb,
      {
        inGame,
        componentTheme: theme,
        kind: "button",
        ...thumbProps
      }
    ),
    renderOptionsList: Options,
    popupGap,
    arrow: true,
    searchClearButton: true,
    popupClassName: cx(
      newTheme["currency-dropdown-popup-new"],
      "currency-dropdown-popup",
      "currency-dropdown-popup-new"
    ),
    searchPlaceholder: text.searchPlaceholder
  },
  /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.filter, {
        [styles[theme]]: !!theme
      })
    },
    /* @__PURE__ */ React.createElement(
      Switch,
      {
        flow: "reverse",
        isFullWidth: true,
        isChecked: isFiat,
        size: "large",
        theme: theme === "blue" ? "dark" : theme,
        label: text.fiatSwitch,
        onCheck: setIsFiat
      }
    ),
    /* @__PURE__ */ React.createElement(
      Switch,
      {
        flow: "reverse",
        isFullWidth: true,
        isChecked: isHideZeroBalance,
        size: "large",
        theme: theme === "blue" ? "dark" : theme,
        label: text.zeroSwitch,
        onCheck: setHideZeroBalance
      }
    )
  )
));
CryptoSelect.displayName = "User.CryptoSelect";

export { CryptoSelect };
//# sourceMappingURL=index.js.map
